import React, { useState, useEffect } from 'react'
import c from 'classnames'
import get from 'lodash/get'

import { GeoSearch } from 'discada/dist/Map'
import Button from 'discada/dist/Button'
import { Field, SimpleTextField } from 'discada/dist/Form'
import { ConnectedStateFeeTaxForm } from 'components/forms/StateFeeTaxForm'
import DefaultSection from 'components/config/quote/DefaultSection'
import { creditSort, formatPhone } from 'utils'

import { TradePendingSearchNew } from 'components/Quote/TradePendingSearch'

import './ReactionSection.scss'

export function ReactionSection(props) {
  let { className, title, explainer, children } = props,
    [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(timer)
  })

  return (
    <div
      className={c('reaction-section', className, {
        'reaction-section-visible': visible,
      })}
    >
      {explainer && (
        <div className="reaction-section-explainer">
          <div className="reaction-section-explainer-inner">
            <h4 className="reaction-section-explainer-title">{title}</h4>
            <div className="reaction-section-explainer-content">
              {explainer}
            </div>
          </div>
        </div>
      )}
      {children && <div className="reaction-section-body">{children}</div>}
    </div>
  )
}

////////////////////////
export function ReactionSellCar(props) {
  let { rooftopName } = props

  return (
    <ReactionContact
      {...props}
      title={
        <>
          <span role="img" aria-label="cash">
            💵
          </span>
          Get Cash for my car!
        </>
      }
      explainer={
        <>
          <strong>{rooftopName}</strong> will contact you to schedule a vehicle
          inspection and provide a cash offer. Not all vehicles are eligible for
          cash offer. See dealer for complete details.
        </>
      }
      fieldTitle="How can we reach you?"
    />
  )
}

export function ReactionNoOwn(props) {
  let { onClick } = props

  return (
    <ReactionSection
      {...props}
      title={<>👍 Thanks for the feedback!</>}
      explainer={
        <div>
          <p>
            We'll update our records to show that you no longer own that car. We
            won’t send offers on it anymore.
          </p>
          <br />
          <p>
            <strong>BEFORE YOU GO!</strong> Do you want to see the estimated
            trade value and equity on your current vehicle? Click{' '}
            <strong>Upgrade MY CAR!</strong> below to add your vehicle and see
            your new low payment on every vehicle in our inventory.
          </p>
          <br />
          <Button size="small" onClick={onClick} success icon="car">
            Upgrade <strong>My Car!</strong>
          </Button>
        </div>
      }
    ></ReactionSection>
  )
}

export function ReactionContact(props) {
  let {
    className,
    setValue,
    getValue,
    fieldProps,
    isKnownCustomer,
    resetCustomerTag,
    formState,
    onBlur = () => {},
    title = (
      <>
        <span role="img" aria-label="appraisal">
          📉
        </span>
        Get INVENTORY & PAYMENT UPDATES!
      </>
    ),
    explainer = (
      <>
        Inventory and payments change often! <strong>SAVE YOUR DEAL</strong> to
        be notified and return to your deal in the future.
      </>
    ),
    fieldTitle = 'Save your deal and stay informed',
  } = props

  return (
    <ReactionSection
      className={c('contact-reaction-section', className)}
      title={title}
      explainer={<span>{explainer}</span>}
    >
      <div className="reaction-form-contact-fields">
        <Field label={fieldTitle}>
          {fp => (
            <>
              <Field inline>
                <div className="field">
                  <SimpleTextField
                    {...fp}
                    {...fieldProps}
                    placeholder="Your First Name *"
                    leftIcon="user"
                    value={getValue('customer.firstName')}
                    onChange={setValue('customer.firstName')}
                    onBlur={onBlur}
                  />
                </div>
                <div className="field">
                  <SimpleTextField
                    {...fp}
                    {...fieldProps}
                    placeholder="Your Last Name *"
                    leftIcon="user"
                    value={getValue('customer.lastName')}
                    onChange={setValue('customer.lastName')}
                    onBlur={onBlur}
                  />
                </div>
              </Field>
              <Field inline>
                <div className="field">
                  <SimpleTextField
                    {...fp}
                    {...fieldProps}
                    placeholder="Your Email Address"
                    leftIcon="envelope"
                    value={getValue('customer.email')}
                    onChange={setValue('customer.email')}
                    onBlur={onBlur}
                    validateFor="email"
                    type="email"
                  />
                </div>
                <div className="field">
                  <SimpleTextField
                    {...fp}
                    {...fieldProps}
                    placeholder="Your Phone Number"
                    leftIcon="mobile"
                    value={getValue('customer.phone')}
                    onChange={setValue('customer.phone')}
                    onBlur={onBlur}
                    validateFor="phone"
                    type="tel"
                  />
                </div>
              </Field>
            </>
          )}
        </Field>
        {isKnownCustomer && (
          <div className="control">
            <Button text size="small" onClick={resetCustomerTag}>
              Not {get(formState, 'customer.firstName')}?
            </Button>
          </div>
        )}
      </div>
    </ReactionSection>
  )
}

////////////////////////

export function ReactionTrades() {} // TODO Convert from Trades.js

////////////////////////

export function ReactionRebates() {} // TODO Convert from SimpleRebates.js

////////////////////////

export function ReactionCredit(props) {
  let { className, onChange, value = null } = props

  return (
    <ReactionSection
      className={c('credit-reaction-section', className)}
      title={
        <>
          <span role="img" aria-label="appraisal">
            🏦
          </span>
          Get Your Rate!
        </>
      }
      explainer={
        <span>
          Select your <strong>CREDIT SCORE</strong> range for the most accurate
          available financing options and payments. Then click See{' '}
          <strong>YOUR</strong> Payments!
        </span>
      }
    >
      <div className="reaction-form-credit-fields">
        <Field label="How's your credit?">
          <DefaultSection
            allowAll
            hideAlt
            sort={creditSort}
            allowCustom={false}
            valueKey="creditScore"
            valuesKey="creditTiers"
            selected={value}
            onChange={onChange}
            labelRenderer={v => (
              <span className="credit-option">
                <strong>{v.label}</strong>
                <span> {v.value || 800}+</span>
              </span>
            )}
          />
        </Field>
      </div>
    </ReactionSection>
  )
}

////////////////////////

export function ReactionLocation(props) {
  let {
    className,
    fieldProps,
    zip,
    onZipChange,
    onGeoSelect,
    onTaxRegionSelect,
    formState,
  } = props

  let taxRegionId =
    get(formState, 'customer.location.taxRegionId') ||
    get(formState, 'customer.taxRegionId')

  return (
    <ReactionSection
      className={c('location-reaction-section', className)}
      title={
        <>
          <span role="img" aria-label="appraisal">
            📍
          </span>
          Get your Taxes & Fees!
        </>
      }
      explainer={
        <span>
          Enter your <strong>ZIP CODE</strong> to automatically calculate taxes,
          license plate and registration fees. It will also improve the accuracy
          of rebates and trade allowance applied to your payments. Click See{' '}
          <strong>YOUR</strong> Payments!
        </span>
      }
    >
      <div className="reaction-form-location-fields">
        <Field className="reaction-geo" label="What's your zip code?">
          <GeoSearch
            xgeolocate
            {...fieldProps}
            value={zip}
            onChange={onZipChange}
            onSelect={onGeoSelect}
            buttonLabel="Find my Zip"
            errorMessage="Location access failed, please enter your zip code"
          />
          <ConnectedStateFeeTaxForm
            {...fieldProps}
            autoSelect
            zip={zip}
            taxRegionId={taxRegionId}
            onChange={onTaxRegionSelect}
          />
        </Field>
      </div>
    </ReactionSection>
  )
}

////////////////////////

export function ReactionSaved({ rooftopName, rooftopPhone }) {
  return (
    <ReactionSection
      className={c('location-reaction-section')}
      title={
        <>
          <span role="img" aria-label="appraisal">
            👍
          </span>
          Thanks for your interest!
        </>
      }
      explainer={
        <span>
          {rooftopName} will contact you to setup the vehicle inspection.
          <br />
          <br />
          Feel free to browse our entire inventory and see your low payment
          options with estimated trade equity included.
          <br />
          <br />
          {rooftopPhone && (
            <>
              Call us at{' '}
              <a href="tel:{rooftopPhone}">{formatPhone(rooftopPhone)}</a> with
              any questions.
            </>
          )}
        </span>
      }
    ></ReactionSection>
  )
}
